export var handshakeCode = 'wix-sdk-bo-hello-handshake';
var origins = ['https://manage.wix.com', 'https://manage.editorx.com'];
var allowedOrigins = new Set(origins);
var protocolVersion = '1.0.0';
export function handshake(_a) {
    var postMessage = _a.postMessage, origin = _a.origin;
    if (!origin) {
        throw new Error('Origin must be provided in the URL search params.');
    }
    if (!allowedOrigins.has(origin)) {
        throw new Error("Invalid origin. Can't handshake with provided origin");
    }
    var _b = new MessageChannel(), widgetPort = _b.port1, hostPort = _b.port2;
    var message = {
        code: handshakeCode,
        version: protocolVersion,
        port: hostPort,
    };
    postMessage(message, origin, [hostPort]);
    return widgetPort;
}
//# sourceMappingURL=handshake.js.map